import type { QueryParams, SortOption } from './DefaultQueryFormatter'
import DefaultQueryFormatter from './DefaultQueryFormatter'

export default class NewsQueryFormatter extends DefaultQueryFormatter {
  override getDefaultFilters(_params: QueryParams = {}): {
    states: string[]
    audiences: string[]
    topics: string[]
  } {
    return {
      states: [],
      audiences: [],
      topics: [],
    }
  }

  override getSortOptions(_params: QueryParams = {}): SortOption[] {
    return [
      { label: 'Most Recent', value: 'first_published_at:desc' },
      { label: 'Oldest', value: 'first_published_at:asc' },
      { label: 'A–Z', value: 'name:asc' },
      { label: 'Z–A', value: 'name:desc' },
    ]
  }
}
